import { createSlice } from '@reduxjs/toolkit';
import { fetchTopClearings } from '../actions/terrainActions';
import { TopClearingItem } from '../types/terrain.types';

interface TopClearingsState {
  clearings: TopClearingItem[];
  loading: boolean;
  lastFetched: number | null;
}

const initialState: TopClearingsState = {
  clearings: [],
  loading: false,
  lastFetched: null,
};

const topClearingsSlice = createSlice({
  name: 'topClearings',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTopClearings.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchTopClearings.fulfilled, (state, action) => {
        state.clearings = action.payload;
        state.loading = false;
        state.lastFetched = Date.now();
      })
      .addCase(fetchTopClearings.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const selectTopClearings = (state: AppState) => state.topClearings.clearings;
export const selectTopClearingsLoading = (state: AppState) => state.topClearings.loading;
export const selectTopClearingsLastFetched = (state: AppState) => state.topClearings.lastFetched;

export default topClearingsSlice.reducer;
